/**
 * Doit être aligné avec PAYMENT_ENABLED côté backend (false = mode test sans Stripe).
 * Build : REACT_APP_PAYMENT_ENABLED=false ou VITE_PAYMENT_ENABLED=false
 */
export function isPaymentEnabled() {
  const v =
    (typeof import.meta !== "undefined" && import.meta.env?.VITE_PAYMENT_ENABLED) ??
    process.env.VITE_PAYMENT_ENABLED ??
    process.env.REACT_APP_PAYMENT_ENABLED;
  if (v === undefined || v === "") return true;
  return String(v).trim().toLowerCase() !== "false";
}
